/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class WxComplianceService {

    /**
     * Update an applicant compliance profile
     * Applies a WX compliance profile to an applicant. Restricted to WX service-to-service tokens: a WX-signed JWT with the Fountain API audience. An account API token or an employer user session token is rejected.
     * @param applicantExternalId
     * @param authorization Bearer <WX service JWT>
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static putInternalApiWxApplicantsComplianceProfile(
        applicantExternalId: string,
        authorization: string,
        requestBody: {
            compliance_profile: {
                workerUuid: string;
                companyUuid: string;
                worker: {
                    applicantId: string;
                };
                compositeStatus: 'IN' | 'OUT' | 'UNMONITORED' | 'PENDING_REVIEW' | 'EXPIRING_SOON';
                assignedRequirements: any;
                updatedAt: string;
            };
        },
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/internal_api/wx/applicants/{applicant_external_id}/compliance_profile',
            path: {
                'applicant_external_id': applicantExternalId,
            },
            headers: {
                'Authorization': authorization,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden when the WX compliance stage is disabled`,
                404: `not found`,
                422: `invalid profile`,
            },
        });
    }

}